module.exports = __webpack_public_path__ + "static/img/21.39f8ed3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/eng/21.png
// module id = iu/s
// module chunks = 0